import produce from 'immer'
import constants from '../constants/brainstormers'

const initialState = {
  brainstormers: {},
  schedules: {},
  fetching: false,
  doneFetching: false,
  fetchError: ''
}

export default produce((draft, action) => {
  switch (action.type) {
    case constants.FETCH_BRAINSTORMERS_REQUEST:
      draft.fetching = true
      break
    case constants.FETCH_BRAINSTORMERS_SUCCESS:
      draft.fetching = false
      draft.doneFetching = true
      draft.fetchError = ''
      draft.brainstormers = action.brainstormers
      for (const key in action.brainstormers) {
        draft.schedules[key] = {
          fetching: false,
          doneFetching: false,
          fetchError: ''
        }
      }
      break
    case constants.FETCH_BRAINSTORMERS_FAILURE:
      draft.fetching = false
      draft.doneFetching = true
      draft.fetchError = action.errorMessage
      break
    case constants.REORDER_BRAINSTORMERS:
      for (const key in action.updates) {
        draft.brainstormers[key].sequence = action.updates[key]
      }
      break
    case constants.RESET_BRAINSTORMERS:
      return initialState
    case constants.FETCH_SCHEDULE_REQUEST:
      draft.schedules[action.id].fetching = true
      break
    case constants.FETCH_SCHEDULE_SUCCESS:
      draft.schedules[action.id].fetching = false
      draft.schedules[action.id].doneFetching = true
      draft.schedules[action.id].fetchError = ''
      for (const key in action.schedule) {
        draft.schedules[action.id][key] = action.schedule[key]
      }
      break
    case constants.FETCH_SCHEDULE_FAILURE:
      draft.schedules[action.id].fetching = false
      draft.schedules[action.id].doneFetching = true
      draft.schedules[action.id].fetchError = action.errorMessage
      break
    case constants.SAVE_SCHEDULE_REQUEST:
      draft.schedules[action.id].saving = true
      break
    case constants.SAVE_SCHEDULE_SUCCESS:
      draft.schedules[action.id].saving = false
      draft.schedules[action.id].saveError = ''
      draft.schedules[action.id].errors = {}
      for (const key in action.schedule) {
        draft.schedules[action.id][key] = action.schedule[key]
      }
      break
    case constants.SAVE_SCHEDULE_FAILURE:
      draft.schedules[action.id].saving = false
      draft.schedules[action.id].saveError = action.errorMessage
      draft.schedules[action.id].errors = action.errors
      break
    case constants.RESET_SCHEDULE_ERRORS:
      draft.schedules[action.id].errors = {}
      break
    case constants.DESTROY_SCHEDULE_REQUEST:
      draft.schedules[action.id].destroying = true
      break
    case constants.DESTROY_SCHEDULE_SUCCESS:
      draft.schedules[action.id].destroying = false
      draft.schedules[action.id].destroyError = ''
      delete draft.schedules[action.id].action
      delete draft.schedules[action.id].scheduledAt
      break
    case constants.DESTROY_SCHEDULE_FAILURE:
      draft.schedules[action.id].destroying = false
      draft.schedules[action.id].destroyError = action.errorMessage
      break
    case constants.PUBLISH_BRAINSTORMER_REQUEST:
    case constants.UNPUBLISH_BRAINSTORMER_REQUEST:
    case constants.ARCHIVE_BRAINSTORMER_REQUEST:
    case constants.UNARCHIVE_BRAINSTORMER_REQUEST:
    case constants.DESTROY_BRAINSTORMER_REQUEST:
      draft.brainstormers[action.id].transitioning = true
      break
    case constants.PUBLISH_BRAINSTORMER_SUCCESS:
    case constants.UNARCHIVE_BRAINSTORMER_SUCCESS:
      draft.brainstormers[action.id].state = 'published'
      draft.brainstormers[action.id].transitioning = false
      draft.brainstormers[action.id].transitionError = ''
      break
    case constants.UNPUBLISH_BRAINSTORMER_SUCCESS:
      draft.brainstormers[action.id].state = 'draft'
      draft.brainstormers[action.id].transitioning = false
      draft.brainstormers[action.id].transitionError = ''
      break
    case constants.ARCHIVE_BRAINSTORMER_SUCCESS:
      draft.brainstormers[action.id].state = 'archived'
      draft.brainstormers[action.id].archivalReasonMessage = action.archivalReasonMessage
      draft.brainstormers[action.id].transitioning = false
      draft.brainstormers[action.id].transitionError = ''
      break
    case constants.DESTROY_BRAINSTORMER_SUCCESS:
      delete draft.brainstormers[action.id]
      break
    case constants.PUBLISH_BRAINSTORMER_FAILURE:
    case constants.UNPUBLISH_BRAINSTORMER_FAILURE:
    case constants.ARCHIVE_BRAINSTORMER_FAILURE:
    case constants.UNARCHIVE_BRAINSTORMER_FAILURE:
    case constants.DESTROY_BRAINSTORMER_FAILURE:
      draft.brainstormers[action.id].transitioning = false
      draft.brainstormers[action.id].transitionError = action.errorMessage
      break
  }
}, initialState)
